/** Where the web app should go after sign-in.
 *  `remote` undefined means the wallet request failed.
 *  `null` means this account has no wallet — including right after a reset.
 */
export function decideWebGate(
  hasStoredSeed: boolean,
  remote: object | null | undefined,
): 'recover' | 'setup' | 'import' | 'retry' | 'app' {
  if (remote === undefined) return 'retry';
  if (remote === null) return hasStoredSeed ? 'recover' : 'setup';
  return hasStoredSeed ? 'app' : 'import';
}
